export enum WeatherStationProvider {
  ARABLE = 'ARABLE',
  DAVIS = 'DAVIS',
  PESSL = 'PESSL',
  SENCROP = 'SENCROP',
  ALSIA = 'ALSIA',
  ASSAM = 'ASSAM',
  WEENAT = 'WEENAT',
  CESENS = 'CESENS',
  NETSENS = 'NETSENS',
  NESA = 'NESA',
  BARILLA = 'BARILLA',
  IKOS = 'IKOS',
  IKOSTECH = 'IKOSTECH',
  VIRTUALDEVICE = 'VIRTUALDEVICE',
  UNKNOWN = 'UNKNOWN',
}
